















import Vue from 'vue'
import { mapState } from 'vuex'
import Snackbar from '@/components/Snackbar.vue'
import Transitions from '@/mixins/Transitions'
import SecondaryNav from '@/components/SecondaryNav.vue'
import Bottom from '@/components/Bottom.vue'
// import IssueCollector from '@/components/IssueCollector.vue'
import Top from '@/components/Top.vue'
import { Town } from '@/store/towns/types'
import { eventHub } from '@/store/eventHub'
import i18nextConfig from '@/helpers/i18next-config'
import { vue_app_version } from '@/helpers/constants'

export default Vue.extend({
  name: 'App',
  components: {
    Bottom: Vue.extend(Bottom),
    // IssueCollector: Vue.extend(IssueCollector),
    SecondaryNav: Vue.extend(SecondaryNav),
    Snackbar: Vue.extend(Snackbar),
    Top: Vue.extend(Top)
  },
  mixins: [ Vue.mixin(Transitions) ],
  computed: {
    ...mapState('auth', ['user', 'authenticated']),
    ...mapState('towns', ['towns'])
  },
  created() {
    eventHub.$on('websocketHello',
      () => Vue.set(this, 'wssHelloReceived', true))
    if(i18nextConfig.lng) {
      this.$vuetify.lang.current = i18nextConfig.lng
    } else {
      console.log('not set')
    }
    this.addFavicon()
    this.addVersionMetaTag()
    this.setTownsAlpha(this.towns)
  },
  data() {
    return {
      townsAlpha: [],
      wssHelloReceived: false
    }
  },
  methods: {
    addFavicon() {
      const head = document.getElementsByTagName('head')[0]
      const tag = document.createElement('link')
      tag.setAttribute('rel', 'icon')
      tag.setAttribute('href', 'https://' + location.host + '/images/favicon.ico')
      head.appendChild(tag)
    },
    addVersionMetaTag() {
      if(typeof vue_app_version === 'string') {
        const head = document.getElementsByTagName('head')[0]
        const tag = document.createElement('meta')
        tag.setAttribute('name', 'tfn-version')
        tag.setAttribute('content', vue_app_version)
        head.appendChild(tag)
      }
    },
    alphaSort(a: Town, b: Town) {
      if (a.name < b.name) return -1
      if (a.name > b.name) return 1
      return 0
    },
    setTownsAlpha(v: Town[]) {
      const sorted = Object.values(v).sort(this.alphaSort as (a: unknown, b: unknown) => number)
      Vue.set(this, 'townsAlpha', sorted)
    }
  },
  watch: {
    towns(v) {
      this.setTownsAlpha(v)
    }
  }
})
